<template>
	<div class="global-forms">
		<ul
			class="results-list results-list--global-forms"
			:id="uid"
			:variant="variant"
		>
			<li
				:id="`${uid}_list`"
				class="results-list__item"
				v-for="form in source"
				:key="form.id"
			>
				<GlobalFormCard
					:id="`${uid}_${form.id}_form`"
					:form="form"
					@click="clickGlobalFormCard"
				/>
			</li>
		</ul>
		<ManageCustomersEditFlyout
			v-model="showFlyout"
			:form="form"
			@toast="updateToast"
		/>
	</div>
</template>

<script>
import GlobalFormCard from './global-forms-card';
import ManageCustomersEditFlyout from '@/views/global-forms/manage-customers-edit-flyout.vue';

export default {
	name: 'FormList',
	components: {
		GlobalFormCard,
		ManageCustomersEditFlyout
	},
	props: {
		source: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			showFlyout: false,
			form: {}
		};
	},
	methods: {
		clickGlobalFormCard(obj) {
			this.form = obj;
			this.showFlyout = true;
		},
		updateToast(val) {
			this.$store.dispatch('toastMessages/show', {
				toastId: 'global-forms.action',
				statusCode: val.status,
				message: val.message,
				slot: 'default',
				useIcon: true,
				userDismissable: true
			});
		}
	}
};
</script>

<style lang="scss"></style>
